/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {SENSOR_TYPES} from "../../../constants/globalVariables";

const sensorCameraHeaderTitle = "Camera Database"

const addCameraEndpoint = `/HttpTriggerSensors?req=add&type=${SENSOR_TYPES.CAMERA}`
const addCameraConfigEndpoint = "/HttpTriggerSensors?req=add&type=camera-config"
const deleteCameraConfigEndpoint = '/HttpTriggerSensors?req=delete&type=camera-config'
const getCameraDetailsEndpoint = "/HttpTriggerSensors?req=get&type=camera-details"
const getCameraLandingEndpoint = "/HttpTriggerSensors?req=get&type=camera-landing"
const getCameraPlotEndpoint = "/HttpTriggerSensors?req=get&type=camera-plot"
const uploadFileCameraEndpoint = `/HttpTriggerSensors?req=upload-file&type=${SENSOR_TYPES.CAMERA}`
const deleteCameraTempFileEndpoint = "/HttpTriggerSensors?req=delete&type=camera-temp-file"

export interface ImagerRow{
  height : string,
  label : string,
  mp : number,
  required : boolean,
  width: number
}
export interface LensRow {
  fov: number, 
  paraxial_height: number, 
  real_height: number,
  op_distance: number,
  angular_resolution: number 
}
export {
  sensorCameraHeaderTitle, 
  addCameraEndpoint,
  addCameraConfigEndpoint,
  deleteCameraConfigEndpoint,
  getCameraDetailsEndpoint, 
  getCameraLandingEndpoint, 
  getCameraPlotEndpoint,
  uploadFileCameraEndpoint, 
  deleteCameraTempFileEndpoint
} 